import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/main.scss';
import App from './App';
import i18n from './i18n';
import { Provider } from 'react-redux'
import store from './redux/store';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App i18n={i18n}/>
  </Provider>
);
